import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Heading, Card, CardHeader, CardBody, Text } from "@chakra-ui/react";
import Swal from "sweetalert2";

export default function Contact() {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "76f769a8-c0af-44b4-be50-227002df572d");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      Swal.fire({
        title: "Čestitamo!",
        text: "Poruka je uspešno poslata!",
        icon: "success",
        confirmButtonColor: "#C9342D",
      });
      event.target.reset();
    } else {
      Swal.fire({
        title: "Greška!",
        text: "Molimo Vas pokušajte ponovo",
        icon: "error",
        confirmButtonColor: "#C9342D",
      });
    }
  };

  return (
    <Card
      className="faq-container"
      id="contact"
      bg="rgba(248, 249, 250, 1)"
      borderRadius="lg"
      boxShadow="lg"
      p={0}
      w={{ sm: "90%", "2xl": "50%" }}
      mx="auto"
    >
      <CardHeader textAlign="center">
        <Heading
          textAlign="center"
          as="h1"
          size={{ "2xl": "xl", lg: "xl" }}
          color="#C9342D"
        >
          Kontaktirajte nas
        </Heading>
        <Text>
          Popunite formu i u što kraćem vremenskom roku kontaktiraće Vas član
          našeg tima.
        </Text>
      </CardHeader>
      <CardBody>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>Ime</Form.Label>
            <Form.Control
              type="text"
              placeholder="Unesite svoje ime"
              name="ime"
              required
            />
            <Form.Text className="form-subtext">
              *Ovo polje je obavezno
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicLastName">
            <Form.Label>Prezime</Form.Label>
            <Form.Control
              type="text"
              placeholder="Unesite svoje prezime"
              name="prezime"
              required
            />
            <Form.Text className="form-subtext">
              *Ovo polje je obavezno
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicCompany">
            <Form.Label>Kompanija</Form.Label>
            <Form.Control
              type="text"
              placeholder="Unesite ime kompanije"
              name="kompanija"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              type="email"
              placeholder="Unesite svoju e-mail adresu"
              name="e-mail"
              required
            />
            <Form.Text className="form-subtext">
              *Ovo polje je obavezno
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPhone">
            <Form.Label>Telefon</Form.Label>
            <Form.Control
              type="phone"
              placeholder="Unesite broj telefona"
              name="broj telefona"
            />
          </Form.Group>

          <Button className="contact-button" type="submit">
            Pošaljite
          </Button>
        </Form>
      </CardBody>
    </Card>
  );
}
